import { create } from 'zustand';
import axios from 'axios';

const API_BASE_URL = '/api'; // Sesuaikan dengan URL backend Anda

const useAuthStore = create((set) => ({
  token: localStorage.getItem('token') || null,
  user: JSON.parse(localStorage.getItem('user')) || null,
  isAuthenticated: !!localStorage.getItem('token'),
  loading: false,
  error: null,

  login: async (username, password) => {
    set({ loading: true, error: null });
    try {
      const response = await axios.post(`${API_BASE_URL}/login`, { username, password });
      const { token, user } = response.data;
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      set({ token, user, isAuthenticated: true, loading: false });
      return user; // Mengembalikan user untuk navigasi atau penggunaan lain
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Login gagal';
      set({ error: new Error(errorMessage), loading: false });
      throw new Error(errorMessage); // Re-throw error for component to catch
    }
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    set({ token: null, user: null, isAuthenticated: false });
  },

  // Fungsi untuk memeriksa token saat aplikasi dimuat ulang
  checkAuth: () => {
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user'));
    if (token && user) {
      set({ token, user, isAuthenticated: true });
    } else {
      set({ token: null, user: null, isAuthenticated: false });
    }
  },
}));

export default useAuthStore;
